module.exports = __webpack_public_path__ + "static/media/tingting.3ad57aba.mp3";